import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 4.641 8',
  width = '4.641',
  className = '',
  height = '8',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g id="left-caret" transform="rotate(90 2.32 2.32)">
      <path
        fill={fill}
        fillRule="evenodd"
        d="M4 4.64L0 .792.824 0 4 3.056 7.176 0 8 .792z"
      />
    </g>
  </svg>
);
export default SVG;
